export default function (str: string, ...args: string[]): string {
  let formatedStr = str
  args.forEach((value, index) => {
    while (formatedStr.includes(`{${index}}`)) {
      formatedStr = formatedStr.replace(`{${index}}`, value)
    }
  })
  return formatedStr
}
